import React from 'react';
import './LongTermScheduleCalendar.scss';
import moment from 'moment';
import LtsJobCard from './LtsJobCard';
import cls from 'classnames';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { MomentDateFormat } from '../MomentDateFormat';

export default class LtsDayCell extends React.Component {
    constructor(props) {
        super(props);

        this.state = { showModal: false };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    buildEventsByDate = () => {
        const { events } = this.props;
        const byDate = {};
        events.forEach((ev) => {
            const key = moment(ev.start).format('YYYY-MM-DD');

            if (!byDate[key]) {
                byDate[key] = [];
            }

            byDate[key].push(ev);
        });

        return byDate;
    };

    buildCrewCountByDate = () => {
        const { events } = this.props;

        const sets = {};

        events.forEach((ev) => {
            const key = moment(ev.start).format('YYYY-MM-DD');
            if (!sets[key]) sets[key] = new Set();
            sets[key].add(ev.crewId);
        });

        const counts = {};
        Object.entries(sets).forEach(([k, v]) => {
            counts[k] = v.size;
        });

        return counts;
    };

    getMissingCrews = (dayEvents) => {
        const { crews } = this.props;

        return crews.filter((c) => !dayEvents.some((de) => de.crewId == c.id));
    };

    render() {
        const { showModal } = this.state;
        const { dateStr, searchFilter } = this.props;

        const { crews } = this.props;

        const totalCrews = crews.length;
        const eventsByDate = this.buildEventsByDate();
        const crewCountByDate = this.buildCrewCountByDate();

        const searchFilterRegEx = new RegExp(searchFilter, 'i');

        const dayEvents = (eventsByDate[dateStr] || []).filter(
            (de) =>
                !searchFilter ||
                de.contractNumber.match(searchFilterRegEx) ||
                de.crewName.match(searchFilterRegEx) ||
                de.divisionName.match(searchFilterRegEx)
        );

        const remaining = totalCrews - (crewCountByDate[dateStr] || 0);
        const m = moment(dateStr);
        const isToday = m.isSame(moment(), 'day');
        const isWeekend = m.day() === 0 || m.day() === 6;

        const missingCrews = this.getMissingCrews(dayEvents);

        return (
            <>
                <div
                    key={dateStr}
                    className={cls('lts-day-cell', {
                        'lts-today': isToday,
                        'lts-weekend': isWeekend,
                    })}
                >
                    <div className="lts-day-header" onClick={this.toggleModal}>
                        <span className="lts-day-label">
                            {m.format(MomentDateFormat.ShortMonthAndDay)}
                        </span>
                        <span className="lts-crew-badge">{remaining}</span>
                    </div>
                    <div className="lts-day-jobs">
                        {dayEvents.map((de) => (
                            <LtsJobCard
                                key={de.id}
                                event={de}
                                {...this.props}
                            />
                        ))}
                    </div>
                </div>

                <Modal
                    isOpen={showModal}
                    fade={false}
                    toggle={this.toggleModal}
                >
                    <ModalHeader toggle={this.toggleModal}>
                        Unassigned Crews -{' '}
                        {m.format(MomentDateFormat.WeekDayNameAndDate)}
                    </ModalHeader>
                    <ModalBody>
                        {missingCrews.length === 0 && (
                            <>There were no unassigned crews.</>
                        )}

                        {missingCrews.length > 0 && (
                            <div>
                                <div>
                                    There are {missingCrews.length} crews with
                                    no assignments for{' '}
                                    {m.format(
                                        MomentDateFormat.WeekDayNameAndDate
                                    )}
                                    .
                                </div>
                                <div>
                                    <ul>
                                        {missingCrews.map((c) => (
                                            <li key={c.id}>{c.name}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        )}
                    </ModalBody>
                </Modal>
            </>
        );
    }
}
